export default "__VITE_ASSET__DfwZqLTq__"